module.exports = __webpack_public_path__ + "img/persil_frise.1c18c9e6.jpg";